// Generado por tools/actualizar-tasas.mjs — Thu, 08 Oct 2026 00:02:31 +0000
window.MT_TASAS = {"GBP":0.7565,"CAD":1.4243,"AUD":1.4363,"EUR":0.8929,"MXN":18.0066,"BRL":5.0027,"CLP":974.4312,"COP":3236.841,"ARS":1520.7136,"PEN":3.4433,"UYU":40.1857};
